export default {
  /**
   * Tắt hết
   */
  CloseAll: 0,
  /**
   * Chỉ hiển snack bar nhỏ
   */
  ShowSmall: 1,
  /*
   * Chỉ hiển thị màn hướng dẫn
   */
  ShowExpend: 2,
};
